export default __webpack_public_path__ + "static/little-book-3ee58ba56fbe86a1754d5d6ecdb87bbb.jpg";